<template>
  <VSnackbar
    v-model="visible"
    top
    right
    :timeout="8000"
    class="night-card-link-error-snackbar"
    data-test="night-card-link-error-snackbar"
  >
    <div
      class="night-card-link-error-snackbar__toast d-flex"
      role="alert"
    >
      <div class="night-card-link-error-snackbar__icon d-flex align-center justify-center flex-shrink-0">
        <VIcon color="textWhite" size="28">
          mdi-alert
        </VIcon>
      </div>
      <div class="night-card-link-error-snackbar__message body-1 textPrimary--text d-flex align-center">
        {{ message }}
      </div>
    </div>
  </VSnackbar>
</template>

<script lang="ts">
export default {
  name: 'SNightCardLinkErrorSnackbar',
};
</script>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import mapNightCardLinkError from '@slg/web-customer-shared/src/utils/mapNightCardLinkError';
import { NIGHT_CARD_LINK_ERROR_EVENT } from '@slg/web-customer-shared/src/utils/nightCardLinkErrorEvents';
import { useI18n, useVm } from '../../composables';

const { t } = useI18n();
const vm = useVm();

const visible = ref(false);
const message = ref('');

function onNightCardLinkError(error: any) {
  message.value = mapNightCardLinkError(error, t);
  visible.value = true;
}

onMounted(() => {
  vm.$root.$on(NIGHT_CARD_LINK_ERROR_EVENT, onNightCardLinkError);
});

onBeforeUnmount(() => {
  vm.$root.$off(NIGHT_CARD_LINK_ERROR_EVENT, onNightCardLinkError);
});
</script>

<style lang="scss" scoped>
.night-card-link-error-snackbar {
  z-index: 300;
}

.night-card-link-error-snackbar::v-deep .v-snack__wrapper {
  min-width: 320px;
  max-width: 400px;
  margin: 72px 16px 0 0;
  background-color: transparent !important;
  box-shadow: none !important;
}

.night-card-link-error-snackbar::v-deep .v-snack__content {
  padding: 0;
}

.night-card-link-error-snackbar__toast {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  background: var(--v-cardBg-base, #fff);
}

.night-card-link-error-snackbar__icon {
  width: 56px;
  min-width: 56px;
  min-height: 56px;
  background-color: var(--v-error-base);
}

.night-card-link-error-snackbar__message {
  flex: 1;
  padding: 12px 16px;
  line-height: 20px;
}
</style>
